import React from 'react';
import s from './custom-video-player.module.scss';
import { PlayerIconButton } from './icon-button';
import { VolumeIndicator } from './volume-indicator';

/**
 * Блок громкости (desktop): кнопка mute + ползунок.
 * Значение ползунка всегда из стейта родителя — элемент никогда не «диктует»
 * свои значения обратно (см. useMediaState).
 */
export const VolumeControl = ({ volume, isMuted, onToggleMute, onVolumeChange }) => {
	const volumeIconState = isMuted || volume === 0 ? 'off' : volume < 0.5 ? 'low' : 'high';
	const displayVolume = isMuted ? 0 : volume;

	return (
		<div className={s.volumeBlock}>
			<PlayerIconButton
				onClick={onToggleMute}
				ariaLabel={isMuted ? 'Включить звук' : 'Выключить звук'}
			>
				<VolumeIndicator size={24} state={volumeIconState} />
			</PlayerIconButton>
			<input
				type="range"
				min={0}
				max={1}
				step={0.05}
				value={displayVolume}
				onChange={onVolumeChange}
				className={s.volumeSlider}
				style={{
					background: `linear-gradient(to right, #fff ${displayVolume * 100}%, rgba(255, 255, 255, 0.25) ${displayVolume * 100}%)`,
				}}
				aria-label="Громкость"
			/>
		</div>
	);
};
